import ReactController from '~/controllers/react_controller'
import AwsRdsMemoryRightSizeRecommendationsCharts from '~/dashboard/aws_rds_memory_right_size_recommendations_charts'

export default class AwsRdsMemoryRightSizeRecommendationsController extends ReactController {
  static values = {
    organizationId: String,
    optimizationId: String,
    resourceId: String,
  }

  createComponent() {
    return (
      <AwsRdsMemoryRightSizeRecommendationsCharts
        organizationId={this.organizationIdValue}
        optimizationId={this.optimizationIdValue}
        resourceId={this.resourceIdValue}
      />
    )
  }
}
